import React from 'react';

/**
 * Conditionally wraps a child component with another component.
 *
 * Based on https://blog.hackages.io/conditionally-wrap-an-element-in-react-a8b9a47fab2
 */
export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: {
  condition: boolean;
  wrapper: (arg: React.ReactElement) => React.ReactElement;
  children: React.ReactElement;
}): React.ReactElement => (condition ? wrapper(children) : children);
